import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import emailjs from '@emailjs/browser';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { useToast } from '../hooks/use-toast';

const ReservationForm = ({ onSuccess }) => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [formData, setFormData] = useState({
    nombre: '',
    telefono: '',
    tipoEvento: '',
    fechaEvento: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSelectChange = (value) => {
    setFormData(prev => ({
      ...prev,
      tipoEvento: value
    }));
  };

  const validatePhone = (phone) => {
    // Remove spaces and dashes
    const cleanPhone = phone.replace(/[\s-]/g, '');
    // Check if it's a valid Argentine phone number (at least 10 digits)
    return /^\d{10,}$/.test(cleanPhone);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation
    if (!formData.nombre.trim()) {
      toast({
        title: "Error",
        description: "Por favor ingresa tu nombre",
        variant: "destructive"
      });
      return;
    }

    if (!formData.telefono.trim()) {
      toast({
        title: "Error",
        description: "El teléfono es obligatorio",
        variant: "destructive"
      });
      return;
    }

    if (!validatePhone(formData.telefono)) {
      toast({
        title: "Error",
        description: "Por favor ingresa un número de teléfono válido (mínimo 10 dígitos)",
        variant: "destructive"
      });
      return;
    }

    if (!formData.tipoEvento) {
      toast({
        title: "Error",
        description: "Por favor selecciona el tipo de evento",
        variant: "destructive"
      });
      return;
    }

    if (!formData.fechaEvento) {
      toast({
        title: "Error",
        description: "Por favor selecciona la fecha del evento",
        variant: "destructive"
      });
      return;
    }

    setIsSubmitting(true);

    try {
      // Send email using EmailJS
      await emailjs.send(
        'service_kke3vgh',
        'template_kb5za7k',
        {
          nombre: formData.nombre,
          telefono: formData.telefono,
          tipoEvento: formData.tipoEvento,
          fechaEvento: formData.fechaEvento,
          to_email: 'saorivestidos@gmail.com' // Email donde quieres recibir
        },
        'wuTGn2dUH1ngyAD5W'
      );

      // Store form data in localStorage for thank you page
      localStorage.setItem('saori_reservation', JSON.stringify(formData));

      // Trigger Meta Pixel Lead event
      if (window.fbq) {
        window.fbq('track', 'Lead');
      }

      toast({
        title: "¡Solicitud enviada!",
        description: "Te contactaremos pronto por WhatsApp",
      });

      // Navigate to thank you page
      setTimeout(() => {
        navigate('/gracias');
      }, 1000);

    } catch (error) {
      console.error('Error sending email:', error);
      toast({
        title: "Error al enviar",
        description: "Hubo un problema. Por favor intenta de nuevo o contactanos por WhatsApp.",
        variant: "destructive"
      });
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="reservation-form">
      <div className="form-group">
        <Label htmlFor="nombre" className="form-label">Nombre *</Label>
        <Input
          id="nombre"
          name="nombre"
          type="text"
          value={formData.nombre}
          onChange={handleChange}
          placeholder="Tu nombre completo"
          className="form-input"
          required
        />
      </div>

      <div className="form-group">
        <Label htmlFor="telefono" className="form-label">Teléfono / WhatsApp *</Label>
        <Input
          id="telefono"
          name="telefono"
          type="tel"
          value={formData.telefono}
          onChange={handleChange}
          placeholder="11 1234 5678"
          className="form-input"
          required
        />
      </div>

      <div className="form-group">
        <Label htmlFor="tipoEvento" className="form-label">Tipo de evento *</Label>
        <Select onValueChange={handleSelectChange} value={formData.tipoEvento}>
          <SelectTrigger className="form-select">
            <SelectValue placeholder="Selecciona tu evento" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="casamiento">Casamiento</SelectItem>
            <SelectItem value="fiesta-15">Fiesta de 15</SelectItem>
            <SelectItem value="egresados">Egresados</SelectItem>
            <SelectItem value="gala">Gala / Evento formal</SelectItem>
            <SelectItem value="recepcion">Recepción</SelectItem>
            <SelectItem value="otro">Otro</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="form-group">
        <Label htmlFor="fechaEvento" className="form-label">Fecha del evento *</Label>
        <Input
          id="fechaEvento"
          name="fechaEvento"
          type="date"
          value={formData.fechaEvento}
          onChange={handleChange}
          className="form-input"
          min={new Date().toISOString().split('T')[0]}
          required
        />
      </div>

      <Button 
        type="submit" 
        className="form-submit-button"
        disabled={isSubmitting}
      >
        {isSubmitting ? 'Enviando...' : 'Consultar disponibilidad'}
      </Button>
    </form>
  );
};

export default ReservationForm;
